module.exports = __webpack_public_path__ + "static/media/0@3x.b5e88021.png";